export const ru = {
    'compact-title': 'Итого'
};
